import bannerSlider from './slider'

export default {
    init() {
        bannerSlider.init()
        this.scrollElement()
        this.servicesTabChanger()

        if ($(window).width() <= 480) {
            this.removeTabs()
        }
    },

    servicesTabChanger(){
        $('.services-tab').click(function() {
            $('.services-tab').removeClass("active");
            $(this).addClass("active")
            var dataLink = $(this).attr("data-associated")
            $('.services-detail').removeClass("service-visible")
            $('#' + dataLink).addClass("service-visible")

            var targetWidth = 992;
            if ( $(window).width() > targetWidth) {
              $([document.documentElement, document.body]).animate({
                  scrollTop: $('#' + dataLink).offset().top
              }, 2000);
              //Add your javascript for screens wider than or equal to 768 here
            } else {

            }
        })
    },

    removeTabs(){
        $('.nav-tabs').removeClass('nav-tabs');
    },

    scrollElement(){
          /******************************
             BOTTOM SCROLL TOP BUTTON
          ******************************/

          // declare variable
          var scrollTop = $(".scrollTop");

          $(window).scroll(function() {
           // declare variable
           var topPos = $(this).scrollTop();

           // if user scrolls down - show scroll to top button
           if (topPos > 500) {
             $(scrollTop).css("opacity", "1");
             $(scrollTop).css('transform', 'scale(1)');


           } else {
             $(scrollTop).css("opacity", "0");
             $(scrollTop).css('transform', 'scale(0.8)');
           }

          }); // scroll END

          //Click event to scroll to top
          $(scrollTop).click(function() {
           $('html, body').animate({
             scrollTop: 0
           }, 800);
           return false;

          }); // click() scroll top EMD
    },

    scrollTabs() {


      const $apartmentSlider = $('.apartment-slider')

      // On before slide change
      if ($apartmentSlider.length) {

        $('.apartment-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
            // console.log(nextSlide);
            var dataID = $('.apartment-slider').find(".slick-active .bedroom-slide").attr("data-id");
            $('.services-tab__tab-item').removeClass('is-visible');
            $('#' + dataID).addClass('is-visible');
        });

      }
        // Variables
        var tabLinks = document.querySelectorAll('.services-tab__link-item');
        var tabContents = document.querySelectorAll('.services-tab__tab-item');

        // Loop through the tab link
        for (var i = 0; i < tabLinks.length; i++) {
        tabLinks[i].addEventListener('click', function(e) {
          e.preventDefault();
          var id = this.hash.replace('#', '');

          // Loop through the tab content
          for (var j = 0; j < tabContents.length; j++) {
            var tabContent = tabContents[j];
            tabContent.classList.remove('is-visible');
            tabLinks[j].classList.remove('is-active');
            if (tabContent.id === id) {
              tabContent.classList.add('is-visible');
            }
          }

          this.classList.add('is-active');
        });
        }
    }


};



// WEBPACK FOOTER //
// ./scripts/routes/templateFlexible.js